<template lang="pug">
  include /mixins
  +b.participant-photo-loader
    +e.title-wrap
      +e.icon.SVG(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(d="M11.1317 3.5C11.5166 2.83333 12.4788 2.83333 12.8637 3.5L21.524 18.5C21.9089 19.1667 21.4277 20 20.6579 20H3.33743C2.56763 20 2.0865 19.1667 2.4714 18.5L11.1317 3.5Z" stroke="#1A1A1A" stroke-width="1.5")
        path(d="M11.2806 13.205C11.2806 13.6321 11.6161 13.9793 12.0301 13.9793C12.4452 13.9793 12.7806 13.6332 12.7806 13.2061L12.7806 7.24502C12.7733 7.04488 12.6911 6.85545 12.5512 6.71653C12.4114 6.57761 12.2248 6.5 12.0306 6.5C11.8365 6.5 11.6499 6.57761 11.5101 6.71653C11.3702 6.85545 11.288 7.04488 11.2806 7.24502L11.2806 13.205Z" fill="black")
        path(d="M11.2929 17.6978C11.4804 17.8913 11.7348 18 12 18C12.2652 18 12.5196 17.8913 12.7071 17.6978C12.8946 17.5043 13 17.2419 13 16.9683C13 16.6947 12.8946 16.4323 12.7071 16.2388C12.5196 16.0453 12.2652 15.9366 12 15.9366C11.7348 15.9366 11.4804 16.0453 11.2929 16.2388C11.1054 16.4323 11 16.6947 11 16.9683C11 17.2419 11.1054 17.5043 11.2929 17.6978Z" fill="black")
      +e.title.P {{ _('Не используйте посторонние изображения. Фото должно быть квадратным, четким, без посторонних. Оно будет использовано для подтверждения личности во время саммита и напечатано на Вашем бейдже.') }}
    +e.content
      validation-provider(
        v-slot="{ errors, validate }"
        :name='name'
        :bails='false'
        :ref='`${name}_valid`'
        rules='required'
      )
        div.relative
          input(
            type='hidden',
            :vid='name'
            :name='name'
            :ref='name'
            v-model='photo'
          )
          +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
          file-loader(
            :width='240'
            :height='240'
            :ratio='1/1'
            :rate='1'
            name='photo'
            :initial='photo'
            :delete-resource='$options.deleteDocument',
            key='item.name'
            @update='setKeys($event)'
          )
    +e.text.P {{ _('Пожалуйста, обратите внимание: загружая фотографии, Вы подтверждаете, что ознакомились с') }} &nbsp;
      +b.tt-link--inline.--styling_default.--black.A.ds-caption--size_sm(:href='offer', target='_blank') {{ _('политикой конфиденциальности') }}
      span &nbsp; {{ _('и у Вас есть все необходимые разрешения на использование этих фотографий. Вы также подтверждаете, что права третьих лиц не нарушены.') }} &nbsp;
</template>

<script>
import {
  createDocument,
  deleteDocument,
} from '@api/ticket_management.service'

import TicketManagementGallery from '@app/TicketManagement/Gallery'

import FileLoader from '@app/TicketManagement/FileLoader'

export default {
  name: 'Education',
  keyGetter: x => `${x.type}`,
  createDocument,
  deleteDocument,
  props: {
    name: {
      default: 'photo',
    },
    form: {},
  },
  components: {
    FileLoader,
    TicketManagementGallery,
  },
  data() {
    return {
      offer: window.offer,
      photo: this.form.photo || null,
    }
  },
  methods: {
    setKeys(keys) {
      this.photo = keys
      this.$emit('input', keys)
    },
    // async createDocument() {
    //   const { data } = await this.createDocument({
    //     type: this.selectedEducationLevel,
    //     file: this.file,
    //   })
    //   this.setKeys(data)
    // },
    // async deleteDocument() {
    //   await this.deleteDocument(this.file)
    //   this.setKeys(null)
    // },
  },
}
</script>
